<template>
  <div id="data-list-list-view" class="data-list-container">
    <data-view-sidebar
      :base="base"
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
    />
    <dashboard-stats-by-priority :stats="stats"/>
    <FilterList
      :customers="customers"
      :priorities="priorities"
      :callBackFilter="callBackFilter"
    />

    <vs-table ref="table" :max-items="itemsPerPage" :data="requests">
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div
          class="flex flex-wrap-reverse items-center data-list-btn-container"
        >
          <div
            v-if="
              profile != '1' &&
              profile != '6' &&
              profile != '2' &&
              profile != '7'
            "
            class="
              btn-add-new
              p-3
              mb-4
              mr-4
              rounded-lg
              cursor-pointer
              flex
              items-center
              justify-center
              text-lg
              font-medium
              text-base text-primary
              border border-solid border-primary
            "
            @click="addNewData"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Nouvelle demande</span>
          </div>
          <div
            @click="refresh()"
            class="
              btn-add-new
              p-3
              mb-4
              mr-4
              rounded-lg
              cursor-pointer
              flex
              items-center
              justify-center
              text-lg
              font-medium
              text-base text-primary
              border border-solid border-primary
            "
          >
            <feather-icon icon="RefreshCwIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Actualiser</span>
          </div>
        </div>
        <div class="con-input-search vs-table--search">
          <input
            v-model="stringSearch"
            @keypress.enter="findRequests()"
            type="text"
            class="input-search vs-table--search-input"
          />
          <i class="vs-icon notranslate icon-scale material-icons null"
            >search</i
          >
        </div>
      </div>

      <template slot="thead">
        <vs-th width="10%" sort-key="ref">N° TICKET</vs-th>
        <vs-th width="10%" sort-key="canal">Canal</vs-th>
        <vs-th width="50%" sort-key="title">Titre</vs-th>
        <vs-th width="5%" sort-key="customer">Client</vs-th>
        <vs-th width="5%" sort-key="service">Application</vs-th>
        <vs-th width="5%" sort-key="departement">Service</vs-th>
        <vs-th width="5%" sort-key="priority">Priorité</vs-th>
        <vs-th width="5%" sort-key="user_owner">Assigné à</vs-th>
        <vs-th width="5%" sort-key="arrived_at">Date d'arrivée</vs-th>
        <vs-th width="5%">Action</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td> {{ tr.ref }}</vs-td>
            <vs-td> {{ tr.canal }}</vs-td>
            <vs-td> {{ tr.title }} </vs-td>
            <vs-td> {{ tr.customer }} </vs-td>
            <vs-td> {{ tr.service }} </vs-td>
            <vs-td> {{ tr.departement }} </vs-td>
            <vs-td>
              <vs-chip
                :color="getPriorityColor(tr.priority)"
                class="product-order-status"
                >{{ tr.priority | title }}</vs-chip
              >
            </vs-td>
            <vs-td>
              <p class="group">{{ tr.user_owner }}</p>
            </vs-td>

            <vs-td>
              <p class="product-price">{{ tr.arrived_at | title }}</p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <div class="flex">
                <div @click="goToSingle(tr.id, tr.has_proved)" class="flex">
                  <feather-icon
                    icon="EyeIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                    class="mr-2"
                  />
                  Détails
                </div>
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <vs-pagination
      v-if="last_page && page"
      :total="last_page"
      v-model="page"
    ></vs-pagination>
  </div>
</template>

<script>
import FilterList from "../FilterList.vue";
import { _buildQuery } from "../../../helpers/helper";

var base_self;
var input_tempon = {
  id: null,
  name: "",
  files: [],
  img_names: [],
  img: [],
  contract: "",
  contract_id: "",
  priority_id: "",
  requests_type_id: "",
  requests_subtype_id: "",
  request_content: "",
  customer_id: "",
  departement_id: "",
  service_id: "",
};

import DataViewSidebar from "../components/DataViewSidebar.vue";
import DashboardStatsByPriority from '../dashboardStatsByPriority.vue';

export default {
  components: {
    FilterList,
    DataViewSidebar,
    DashboardStatsByPriority,
  },
  name: "demandes-received",
  data() {
    return {
      dispatcher: false,
      last_page: 1,
      page: 1,
      filterPrompt: false,
      stringSearch: "",
      customers_contracts: [],
      sub_categories_requests: [],

      priorities: [],
      categories_requests: [],
      customers: [],

      input: JSON.parse(JSON.stringify(input_tempon)),
      input_second: JSON.parse(JSON.stringify(input_tempon)),
      selected: [],
      requestDatas: [],
      itemsPerPage: 50,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      profile: "",
      filter: {
        page: 1,
        client: "",
        priority: "",
        dateDebut: "",
        dateFin: "",
        type: 1,
      },
      services: [],
      departements: [],
      stats: {
        total: 0,
        total_high: 0,
        total_medium: 0,
        total_low: 0
      }
    };
  },
  watch: {
    page(value) {
      if (base_self.stringSearch) {
        base_self.findRequests();
      } else {
        base_self.getRequests(value, base_self.stringSearch);
      }
    },
    input: {
      handler(val) {
        base_self.watch_input_ajout_handler(val);
      },
      deep: true,
    },
  },
  computed: {
    isAdmin() {
      return this.$store.state.AppActiveUser.userRole === "admin";
    },
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    requests() {
      return base_self.requestDatas;
    },
    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.requests.length;
    },
    base() {
      return base_self;
    },
    input_tempon() {
      return input_tempon;
    },
  },
  methods: {
    async getStatsByPriority(page, stringSearch){
      try {
        let { type, client, priority, dateDebut, dateFin } = this.filter;
        let params = {
          page,
          stringSearch,
          type,
          client,
          priority,
          dateDebut,
          dateFin
        }

        let response = await this.$http.get('requests/stats-requests-priority' + _buildQuery(params));
        if (response.data) {
          this.stats.total = response.data.received.requestTotal;
          this.stats.total_high = response.data.received.requestTotalHigh;
          this.stats.total_medium = response.data.received.requestTotalMedium;
          this.stats.total_low = response.data.received.requestTotalLow;
        }
      } catch (error) {
        console.log("error: ", error);
      }
    },
    refresh() {
      base_self.stringSearch = "";
      base_self.page = 1;
      base_self.getRequests(base_self.page, base_self.stringSearch);
    },

    toggleFilterPrompt(val = false) {
      this.filterPrompt = val;
    },
    watch_input_ajout_handler(val) {
      if (
        val.customer_id &&
        val.customer_id !== base_self.input_second.customer_id
      ) {
        base_self.getCustomers_contracts(val.customer_id);
      }

      if (
        val.requests_type_id &&
        val.requests_type_id !== base_self.input_second.requests_type_id
      ) {
        base_self.getSub_categories_requests(val.requests_type_id);
      }

      if (
        val.contract_id &&
        val.contract_id !== base_self.input_second.contract_id
      ) {
        var length = base_self.customers_contracts.length;

        for (let iuoy = 0; iuoy < length; iuoy++) {
          var item = base_self.customers_contracts[iuoy];
          if (val.contract_id === item.id) {
            base_self.input.contract = item.code_contract;
          }
        }
      } else if (
        !val.contract_id &&
        val.contract_id !== base_self.input_second.contract_id
      ) {
        if (base_self.customers_contracts.length) {
          base_self.input.contract_id = base_self.customers_contracts[0].id;
          base_self.input.contract =
            base_self.customers_contracts[0].code_contract;
        }
      }

      if (
        val.customer_id &&
        val.customer_id !== base_self.input_second.customer_id
      ) {
        base_self.getDepartements();
      }

      if (
        val.customer_id &&
        val.customer_id !== base_self.input_second.customer_id
      ) {
        base_self.getDepartements();
      }

      if (
        val.departement_id &&
        val.departement_id !== base_self.input_second.departement_id
      ) {
        base_self.getServices(val.customer_id, val.departement_id);
      }

      base_self.input_second = JSON.parse(JSON.stringify(base_self.input));
    },
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    getPriorityColor(status) {
      status = status.toLowerCase();
      if (status == "normale") return "primary";
      if (status == "basse") return "success";
      if (status == "haute") return "danger";
      return "primary";
    },
    getProgressionColor(num) {
      if (num > 90) return "success";
      if (num > 70) return "primary";
      if (num >= 50) return "warning";
      if (num < 50) return "danger";
      return "primary";
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    goToSingle(id, el) {
      let t = el ? 1 : 2;
      this.$router.push("/requests/" + id + "/detail/" + t);
    },
    async getRequests(page, stringSearch) {
      base_self.$vs.loading();
      let { client, priority, dateDebut, dateFin } = this.filter;
      let type = this.filter.type;
      let response = await base_self.$store.state
        .requests_received(this.filter, {
          page,
          stringSearch,
          type,
          client,
          priority,
          dateDebut,
          dateFin,
        })
        .catch((error) => {
          console.log("error: ", error);
        });
      base_self.last_page = response.data.last_page;
      base_self.requestDatas = response.data.data;
      base_self.getStatsByPriority(base_self.page, base_self.stringSearch);
      base_self.$vs.loading.close();
    },
    async findRequests() {
      if (base_self.stringSearch) {
        base_self.$vs.loading();
        let params = {
          page: base_self.page,
          search: base_self.stringSearch,
          type: this.filter.type,
        };
        let response = await base_self.$store.state
          .findRequests(params)
          .catch((error) => {
            console.log("error: ", error);
          });
        base_self.last_page = response.data.last_page;
        base_self.requestDatas = response.data.data;
        base_self.getStatsByPriority(base_self.page, base_self.stringSearch);
        base_self.$vs.loading.close();
      } else {
        base_self.getRequests(base_self.page, base_self.stringSearch);
      }
    },
    async getPriorities() {
      let response = await base_self.$store.state
        .priorities({})
        .catch((error) => {
          console.log("error: ", error);
        });

      base_self.priorities = response.data;
    },
    async getDepartements() {
      try {
        // this.$vs.loading();
        let response = await this.$http.get("departements");
        this.departements = response.data;
        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading();
        console.log(error);
      }
    },
    async getServices(customer_id, departement_id) {
      try {
        this.$vs.loading();
        let params = {
          customer_id: customer_id,
          departement_id: departement_id,
        };
        let response = await this.$http.get("services" + _buildQuery(params));
        this.services = response.data;
        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading();
        console.log(error);
      }
    },
    async getCategories_requests() {
      let response = await base_self.$store.state
        .categories_requests({}, { paginate: 0 })
        .catch((error) => {
          console.log("error: ", error);
        });

      base_self.categories_requests = response.data;
    },
    async getSub_categories_requests(id) {
      let response = await base_self.$store.state
        .sub_categories_requests({}, id)
        .catch((error) => {
          console.log("error: ", error);
        });

      base_self.sub_categories_requests = response.data;
    },
    async getCustomers() {
      let response = await base_self.$store.state
        .customers({})
        .catch((error) => {
          console.log("error: ", error);
        });

      base_self.customers = response.data;
    },
    async getCustomers_contracts(id) {
      let response = await base_self.$store.state
        .customers_contracts({}, id)
        .catch((error) => {
          console.log("error: ", error);
        });

      base_self.customers_contracts = response.data;
    },
    async callBackFilter(search) {
      let { page, client, priority, dateDebut, dateFin } = search;
      base_self.$vs.loading();
      let type = this.filter.type;
      this.filter.client = search.client;
      this.filter.priority = search.priority;
      this.filter.dateDebut = search.dateDebut;
      this.filter.dateFin = search.dateFin;
      let stringSearch = this.stringSearch;
      let response = await base_self.$store.state
        .requests_received(this.filter, {
          page,
          stringSearch,
          type,
          client,
          priority,
          dateDebut,
          dateFin,
        })
        .catch((error) => {
          console.log("error: ", error);
        });
      base_self.last_page = response.data.last_page;
      base_self.requestDatas = response.data.data;
      base_self.getStatsByPriority(base_self.page, base_self.stringSearch);
      base_self.$vs.loading.close();
    },
  },
  created() {
    base_self = this;
    window.RequestsApp = this;
  },
  async mounted() {
    this.isMounted = true;
    this.dispatcher = window.GETCCMT.$store.state.is_dispatcher();
    this.profile = window.GETCCMT.$store.state.AppActiveUser.profile_id;
    base_self.getRequests(base_self.page, base_self.stringSearch);
    base_self.getPriorities();
    base_self.getCategories_requests();
    base_self.getCustomers();
    base_self.getStatsByPriority(base_self.page, base_self.stringSearch);
    base_self.input.requests_type_id = this.filter.type;

    if (
      base_self.$store.state.is_client() ||
      base_self.$store.state.is_mandataire()
    ) {
      input_tempon.customer_id =
        base_self.$store.state.AppActiveUser.customer_id;
      base_self.input.customer_id =
        base_self.$store.state.AppActiveUser.customer_id;
      await base_self.getCustomers_contracts(
        base_self.$store.state.AppActiveUser.customer_id
      );

      if (base_self.customers_contracts.length) {
        base_self.input.contract_id = base_self.customers_contracts[0].id;
        base_self.input.contract =
          base_self.customers_contracts[0].code_contract;
      }
    }
  },
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 0.5rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: right;
    }
  }
}
</style>
